export default __webpack_public_path__ + "static/media/Montreal Canadiens - Logo.a36ac928.png";